import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from 'vue';
import App from './App.vue';
import axios from 'axios';
import MagentoAxios from './helpers/magento-axios';
import VueSweetalert2 from 'vue-sweetalert2';
import VueMoment from 'vue-moment';
import './plugins/vue-toast';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store';
import './assets/styles.css';
import 'sweetalert2/dist/sweetalert2.css';

Vue.config.productionTip = false;

Vue.prototype.$axios = axios;
// Vue.prototype.$magentoAxios = new MagentoAxios('http://10.147.18.34:8081/api/ext/restaurant-app/');
Vue.prototype.$magentoAxios = new MagentoAxios('https://xb.api.yum.cards/api/ext/restaurant-app/');

Vue.use(VueSweetalert2);
Vue.use(VueMoment);

new Vue({
  vuetify,
  render: h => h(App),
  router,
  store
}).$mount('#app');